import { Box, Button, Stack, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

/**
 * Cabeçalho padrão das páginas (mesmo padrão do konq-backoffice):
 * título forte, subtítulo em cinza e ações alinhadas à direita.
 *
 * - `onBack` + `backLabel`: botão "voltar" discreto acima do título.
 * - `actions`: botões/elementos à direita (quebram pra baixo no mobile).
 */
export default function PageHeader({ title, subtitle, icon, actions, onBack, backLabel, sx }) {
  return (
    <Box sx={{ mb: 3, ...sx }}>
      {onBack && (
        <Button
          size="small"
          color="inherit"
          startIcon={<ArrowBackIcon />}
          onClick={onBack}
          className="no-print"
          sx={{ mb: 1, ml: -1, color: 'text.secondary' }}
        >
          {backLabel}
        </Button>
      )}
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        justifyContent="space-between"
        spacing={2}
      >
        <Stack direction="row" spacing={1.5} alignItems="center" sx={{ minWidth: 0 }}>
          {icon && (
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: 2,
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'primary.main',
                color: 'primary.contrastText',
              }}
            >
              {icon}
            </Box>
          )}
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="h4" sx={{ wordBreak: 'break-word' }}>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="body2" sx={{ mt: 0.5 }}>
                {subtitle}
              </Typography>
            )}
          </Box>
        </Stack>
        {actions && (
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ flexShrink: 0 }}>
            {actions}
          </Stack>
        )}
      </Stack>
    </Box>
  );
}
